import React from 'react';
import { useParams } from 'react-router-dom';
import QRCode from 'react-qr-code';

const CONFIGS = {
  topping: {
    type: 'topping_frozen',
    title: 'Topping Frozen',
    subtitle: 'Encuesta de Satisfacción',
    emoji: '🧊',
    color: '#8B2FC9',
    gradient: 'linear-gradient(135deg, #8B2FC9, #6D28D9)',
    msg: '¡Tu opinión nos ayuda a mejorar!\nEscanea el código QR para completar nuestra encuesta.',
    url: 'https://apptoppingfrozen.com/encuesta/topping',
  },
  heladeria: {
    type: 'heladeria',
    title: 'Heladería',
    subtitle: 'Encuesta de Satisfacción',
    emoji: '🍦',
    color: '#E91E63',
    gradient: 'linear-gradient(135deg, #E91E63, #C2185B)',
    msg: '¿Cómo fue tu experiencia?\nEscanea el código QR y cuéntanos.',
    url: 'https://apptoppingfrozen.com/encuesta/heladeria',
  },
};

export default function SurveyQRPrintPage() {
  const { tipo } = useParams();
  const cfg = CONFIGS[tipo] || CONFIGS.topping;

  return (
    <div style={{ fontFamily:"'Inter','Segoe UI',sans-serif" }}>
      {/* Print styles */}
      <style>{`
        @media print {
          body { margin:0; }
          .no-print { display:none !important; }
          .print-page { break-after:page; }
        }
        @media screen {
          .print-page { margin:24px auto; }
        }
      `}</style>

      {/* Print button */}
      <div className="no-print" style={{ textAlign:'center', padding:16, background:'#f8fafc' }}>
        <button onClick={() => window.print()}
          style={{ padding:'12px 32px', borderRadius:12, border:'none', cursor:'pointer', background:cfg.color, color:'#fff', fontSize:15, fontWeight:700 }}>
          🖨️ Imprimir
        </button>
        <p style={{ fontSize:13, color:'#64748b', marginTop:8 }}>Se imprimen 2 tarjetas por página</p>
      </div>

      {/* Card 1 — Poster grande (para showroom / bodega) */}
      <div className="print-page" style={{
        width:'210mm', minHeight:'297mm', padding:'20mm',
        display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center',
        boxSizing:'border-box',
      }}>
        <div style={{
          width:'100%', maxWidth:420, background:'#fff', borderRadius:32, padding:48,
          boxShadow:'0 4px 24px rgba(0,0,0,.08)', border:`3px solid ${cfg.color}20`,
          textAlign:'center',
        }}>
          <div style={{ fontSize:64, marginBottom:8 }}>{cfg.emoji}</div>
          <h1 style={{ fontSize:28, fontWeight:800, color:'#1e293b', margin:0 }}>{cfg.title}</h1>
          <p style={{ fontSize:16, color:cfg.color, fontWeight:600, margin:'4px 0 24px' }}>{cfg.subtitle}</p>

          <div style={{
            background:'#fff', padding:24, borderRadius:20,
            border:'2px solid #f1f5f9', display:'inline-block', margin:'0 auto',
          }}>
            <QRCode value={cfg.url} size={220} level="H" fgColor={cfg.color} />
          </div>

          <p style={{ fontSize:14, color:'#64748b', marginTop:24, lineHeight:1.6, whiteSpace:'pre-line' }}>{cfg.msg}</p>

          <div style={{
            marginTop:20, padding:'10px 20px', borderRadius:12,
            background:`${cfg.color}10`, border:`1px solid ${cfg.color}30`,
          }}>
            <p style={{ fontSize:12, color:cfg.color, fontWeight:600, margin:0 }}>
              📱 O visita: {cfg.url.replace('https://', '')}
            </p>
          </div>

          <div style={{ marginTop:24, fontSize:11, color:'#94a3b8' }}>
            Topping Frozen © {new Date().getFullYear()} — Gracias por ser parte de nuestra mejora continua
          </div>
        </div>
      </div>

      {/* Cards 2 — Tarjetas pequeñas (4 por página — para mensajero) */}
      <div className="print-page" style={{
        width:'210mm', minHeight:'297mm', padding:'10mm',
        display:'grid', gridTemplateColumns:'1fr 1fr', gridTemplateRows:'1fr 1fr',
        gap:'8mm', boxSizing:'border-box',
      }}>
        {[1, 2, 3, 4].map(i => (
          <div key={i} style={{
            border:`2px solid ${cfg.color}30`, borderRadius:16, padding:20,
            display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center',
            textAlign:'center',
          }}>
            <div style={{ fontSize:28, marginBottom:4 }}>{cfg.emoji}</div>
            <h3 style={{ fontSize:14, fontWeight:700, color:'#1e293b', margin:'0 0 2px' }}>{cfg.title}</h3>
            <p style={{ fontSize:11, color:cfg.color, fontWeight:600, margin:'0 0 10px' }}>{cfg.subtitle}</p>
            <QRCode value={cfg.url} size={100} level="H" fgColor={cfg.color} />
            <p style={{ fontSize:10, color:'#64748b', marginTop:8, lineHeight:1.4 }}>
              Escanea y cuéntanos tu experiencia
            </p>
            <p style={{ fontSize:9, color:'#94a3b8', margin:'4px 0 0' }}>
              {cfg.url.replace('https://', '')}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
